import React from 'react';

import { ICreditCardFormTitle } from './credit-card-form-title.types';

const CreditCardFormTitle: React.FC<ICreditCardFormTitle> = () => null;

export default CreditCardFormTitle;
